import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button, Icon } from '@factorialco/deprecated-design-system'
import {
  ProfileEmployeeResourceFieldDataFragment,
  ValueDataFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import PanesHeader from 'modules/core/components/PanesHeader'
import type { PanesHeaderActionProps } from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import FieldsForm, {
  type ValuableType,
} from 'modules/custom_resources/components/CustomFields/CustomFieldsForm/FieldsForm'
import { getForm } from 'modules/custom_resources/components/CustomFields/CustomFieldsForm/getForm'

interface Props {
  padFormDirection: 'vertical' | 'horizontal'
  boxed: boolean
  title?: string
  description?: string
  icon?: React.ComponentProps<typeof Icon.Large>['icon']
  readonly?: boolean
  headerAction?: PanesHeaderActionProps | null | undefined
  customFieldsOnly?: boolean
  editableFieldsOnly?: boolean
  valuableId: number
  valuableType: ValuableType
  customResourceFieldsData: ProfileEmployeeResourceFieldDataFragment[]
  customValuesData: ValueDataFragment[]
  currency?: string
}

const CustomFieldsForm = ({
  padFormDirection,
  boxed,
  title,
  description,
  icon,
  readonly,
  headerAction,
  customFieldsOnly,
  editableFieldsOnly,
  valuableId,
  valuableType,
  customResourceFieldsData,
  customValuesData,
  currency,
}: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const { forms, hasCustomFieldTypes, isVisible } = getForm(
    customResourceFieldsData,
    customValuesData
  )

  if (!hasCustomFieldTypes || forms.length === 0) return null

  const createNewField = () => {
    navigate(navigation.settings.customizations.fullPath())
  }

  if (customFieldsOnly) {
    return (
      <FieldsForm
        valuableId={valuableId}
        valuableType={valuableType}
        readonly={readonly}
        editableFieldsOnly={editableFieldsOnly}
        forms={forms}
        isVisible={isVisible}
        currency={currency}
      />
    )
  }

  return (
    <PanesPadForm direction={padFormDirection} boxed={boxed}>
      <PanesHeader
        illustration={icon || 'input-field'}
        title={title || i18n.t('settings.custom_fields.title')}
        description={description ?? i18n.t('settings.custom_fields.description')}
        action={headerAction}
      />

      {forms.length === 0 && (
        <Button onClick={createNewField} type="primary">
          {i18n.t('employee_form.create_custom_field')}
        </Button>
      )}

      <FieldsForm
        valuableId={valuableId}
        valuableType={valuableType}
        readonly={readonly}
        forms={forms}
        isVisible={isVisible}
        currency={currency}
      />
    </PanesPadForm>
  )
}

export default observer(CustomFieldsForm)
